import { Directive, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appAppendToBody]',
  standalone: true,
})
export class AppendToBodyDirective implements OnInit, OnDestroy {
  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    const node = this.el.nativeElement;
    this.renderer.setStyle(node, 'position', 'fixed');
    this.renderer.setStyle(node, 'z-index', '20000');
    this.renderer.appendChild(document.body, node);
  }

  ngOnDestroy(): void {
    const node = this.el.nativeElement;
    if (node.parentNode) {
      this.renderer.removeChild(node.parentNode, node);
    }
  }
}
